import { getOwnerId } from "../../../core/game/common/ReplicatedData";
import { ReplicatedAction } from "../../../core/game/interfaces/ReplicatedAction";
function UpdateClueHintValidator(data, context) {
    const { clueId, newClueHint } = data;
    const { clue, gameState } = context;
    // Values must be initalized
    if (clueId.length <= 0 || newClueHint.length <= 0 || gameState.secretWord === undefined) {
        return false;
    }
    // The target clue must exist
    if (clue === undefined || clue.id !== clueId) {
        return `The clue you tried to update has been deleted!`;
    }
    // The target clue must belong to the action caster
    if (getOwnerId(clue) !== getOwnerId(data)) {
        return `You can only update a clue you created!`;
    }
    // Clue may not contain the answer in the clue
    if (newClueHint.toLowerCase().includes(clue.clueAnswer)) {
        return `You can't put the clue answer in the clue hint!`;
    }
    return true;
}
function UpdateClueHintEffect(data, context) {
    var _a;
    (_a = context.clue) === null || _a === void 0 ? void 0 : _a.commitData({
        hints: [...context.clue.data.hints, data.newClueHint]
    });
}
export const UpdateClueHint = new ReplicatedAction('UpdateClueHint', UpdateClueHintValidator, UpdateClueHintEffect);
//# sourceMappingURL=UpdateClueHint.js.map